<!-- <section class="FirstScroll_Section">
  <div class="container-fluid" style="min-height: 50px; background-color: #ddd;margin-top: 20px;">
    <div class="container">
      <div class="col-md-12 col-sm-12 col-xs-12 nopad">
        <div class="col-md-4 col-sm-4 col-xs-12 nopad floatLeft" style="height: 50px;">
          <div class="container-input">
            <input type="text" name="search" autocomplete="off" placeholder="Search.." class="search-term">
            <button type="submit" id="searchBtn" class="search-button"><i class="fa fa-search"></i></button>
          </div>
        </div>
        <div class="col-md-3 col-sm-4 col-xs-12 nopad floatRight" style="height: 50px;">
          <ul class="nav nav-tabs">
            <li class="nav-item">
              <a class="nav-link navLink active" data-toggle="tab" href="#listView"><i class="fa fa-bars"
                  aria-hidden="true"></i> List view</a>
            </li>
            <li class="nav-item">
              <a class="nav-link navLink" data-toggle="tab" href="#gridView"><i class="fa fa-th-large"
                  aria-hidden="true"></i> Grid view</a>
            </li>
          </ul>
        </div>
        <div class="clearfix"></div>
      </div>
    </div>
    <div class="clearfix"></div>
  </div>
  <div class="tab-content" style="min-height: 500px;">
    <div id="gridView" class="container bannerSection boxShadow tab-pane" style="padding:30px;">
      <div class="col-md-12 col-sm-12 col-xs-12 nopad">
        <div class="col-md-3 col-sm-3 col-xs-12 userItem">
          <div class="userCard">
            <div class="userImgContainer">
              <div class="userImgBox">
                <img src="/assets/images/dummyUser.png" class="userImage" />
              </div>
              <h2 class="userName nomargin">Vijay Kumar</h2>
              <h3 class="userDesignation nomargin">Designation</h3>
            </div>
            <div class="userDetails nomargin">
              <p class="userInstitute nomargin">Institute Name</p>
              <p class="userPhone nomargin">09876543210</p>
              <p class="userExt nomargin">Extension</p>
              <p class="userEmail nomargin">vijaykumar@example.com</p>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-3 col-xs-12 userItem">
          <div class="userCard">
            <div class="userImgContainer">
              <div class="userImgBox">
                <img src="/assets/images/dummyUser.png" class="userImage" />
              </div>
              <h2 class="userName nomargin">Vijay Kumar</h2>
              <h3 class="userDesignation nomargin">Designation</h3>
            </div>
            <div class="userDetails nomargin">
              <p class="userInstitute nomargin">Institute Name</p>
              <p class="userPhone nomargin">09876543210</p>
              <p class="userExt nomargin">Extension</p>
              <p class="userEmail nomargin">vijaykumar@example.com</p>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-3 col-xs-12 userItem">
          <div class="userCard">
            <div class="userImgContainer">
              <div class="userImgBox">
                <img src="/assets/images/dummyUser.png" class="userImage" />
              </div>
              <h2 class="userName nomargin">Vijay Kumar</h2>
              <h3 class="userDesignation nomargin">Designation</h3>
            </div>
            <div class="userDetails nomargin">
              <p class="userInstitute nomargin">Institute Name</p>
              <p class="userPhone nomargin">09876543210</p>
              <p class="userExt nomargin">Extension</p>
              <p class="userEmail nomargin">vijaykumar@example.com</p>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-3 col-xs-12 userItem">
          <div class="userCard">
            <div class="userImgContainer">
              <div class="userImgBox">
                <img src="/assets/images/dummyUser.png" class="userImage" />
              </div>
              <h2 class="userName nomargin">Vijay Kumar</h2>
              <h3 class="userDesignation nomargin">Designation</h3>
            </div>
            <div class="userDetails nomargin">
              <p class="userInstitute nomargin">Institute Name</p>
              <p class="userPhone nomargin">09876543210</p>
              <p class="userExt nomargin">Extension</p>
              <p class="userEmail nomargin">vijaykumar@example.com</p>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-3 col-xs-12 userItem">
          <div class="userCard">
            <div class="userImgContainer">
              <div class="userImgBox">
                <img src="/assets/images/dummyUser.png" class="userImage" />
              </div>
              <h2 class="userName nomargin">Vijay Kumar</h2>
              <h3 class="userDesignation nomargin">Designation</h3>
            </div>
            <div class="userDetails nomargin">
              <p class="userInstitute nomargin">Institute Name</p>
              <p class="userPhone nomargin">09876543210</p>
              <p class="userExt nomargin">Extension</p>
              <p class="userEmail nomargin">vijaykumar@example.com</p>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-3 col-xs-12 userItem">
          <div class="userCard">
            <div class="userImgContainer">
              <div class="userImgBox">
                <img src="/assets/images/dummyUser.png" class="userImage" />
              </div>
              <h2 class="userName nomargin">Vijay Kumar</h2>
              <h3 class="userDesignation nomargin">Designation</h3>
            </div>
            <div class="userDetails nomargin">
              <p class="userInstitute nomargin">Institute Name</p>
              <p class="userPhone nomargin">09876543210</p>
              <p class="userExt nomargin">Extension</p>
              <p class="userEmail nomargin">vijaykumar@example.com</p>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-3 col-xs-12 userItem">
          <div class="userCard">
            <div class="userImgContainer">
              <div class="userImgBox">
                <img src="/assets/images/dummyUser.png" class="userImage" />
              </div>
              <h2 class="userName nomargin">Vijay Kumar</h2>
              <h3 class="userDesignation nomargin">Designation</h3>
            </div>
            <div class="userDetails nomargin">
              <p class="userInstitute nomargin">Institute Name</p>
              <p class="userPhone nomargin">09876543210</p>
              <p class="userExt nomargin">Extension</p>
              <p class="userEmail nomargin">vijaykumar@example.com</p>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-3 col-xs-12 userItem">
          <div class="userCard">
            <div class="userImgContainer">
              <div class="userImgBox">
                <img src="/assets/images/dummyUser.png" class="userImage" />
              </div>
              <h2 class="userName nomargin">Vijay Kumar</h2>
              <h3 class="userDesignation nomargin">Designation</h3>
            </div>
            <div class="userDetails nomargin">
              <p class="userInstitute nomargin">Institute Name</p>
              <p class="userPhone nomargin">09876543210</p>
              <p class="userExt nomargin">Extension</p>
              <p class="userEmail nomargin">vijaykumar@example.com</p>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-3 col-xs-12 userItem">
          <div class="userCard">
            <div class="userImgContainer">
              <div class="userImgBox">
                <img src="/assets/images/dummyUser.png" class="userImage" />
              </div>
              <h2 class="userName nomargin">Vijay Kumar</h2>
              <h3 class="userDesignation nomargin">Designation</h3>
            </div>
            <div class="userDetails nomargin">
              <p class="userInstitute nomargin">Institute Name</p>
              <p class="userPhone nomargin">09876543210</p>
              <p class="userExt nomargin">Extension</p>
              <p class="userEmail nomargin">vijaykumar@example.com</p>
            </div>
          </div>
        </div>
      </div>
      <div class="clearfix"></div>
    </div>
    <div id="listView" class="container bannerSection boxShadow tab-pane active" style="padding:30px;">
      <div class="col-md-12 col-sm-12 col-xs-12 nopad">
        <table>
          <thead>
            <tr>
              <th scope="col">Name</th>
              <th scope="col">Designation</th>
              <th scope="col">Institute</th>
              <th scope="col">Phone</th>
              <th scope="col">Extension</th>
              <th scope="col">Email ID</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td scope="row" data-label="Name">Vikas Kumar</td>
              <td data-label="Designation">Teacher</td>
              <td data-label="Institute">Delhi Public School</td>
              <td data-label="Phone">9876543210</td>
              <td data-label="Extension">099</td>
              <td data-label="Email ID">vikaskumar@example.com</td>
            </tr>
            <tr>
              <td scope="row" data-label="Name">Vikas Kumar</td>
              <td data-label="Designation">Teacher</td>
              <td data-label="Institute">Delhi Public School</td>
              <td data-label="Phone">9876543210</td>
              <td data-label="Extension">099</td>
              <td data-label="Email ID">vikaskumar@example.com</td>
            </tr>
            <tr>
              <td scope="row" data-label="Name">Vikas Kumar</td>
              <td data-label="Designation">Teacher</td>
              <td data-label="Institute">Delhi Public School</td>
              <td data-label="Phone">9876543210</td>
              <td data-label="Extension">099</td>
              <td data-label="Email ID">vikaskumar@example.com</td>
            </tr>
            <tr>
              <td scope="row" data-label="Name">Vikas Kumar</td>
              <td data-label="Designation">Teacher</td>
              <td data-label="Institute">Delhi Public School</td>
              <td data-label="Phone">9876543210</td>
              <td data-label="Extension">099</td>
              <td data-label="Email ID">vikaskumar@example.com</td>
            </tr>
            <tr>
              <td scope="row" data-label="Name">Vikas Kumar</td>
              <td data-label="Designation">Teacher</td>
              <td data-label="Institute">Delhi Public School</td>
              <td data-label="Phone">9876543210</td>
              <td data-label="Extension">099</td>
              <td data-label="Email ID">vikaskumar@example.com</td>
            </tr>
            <tr>
              <td scope="row" data-label="Name">Vikas Kumar</td>
              <td data-label="Designation">Teacher</td>
              <td data-label="Institute">Delhi Public School</td>
              <td data-label="Phone">9876543210</td>
              <td data-label="Extension">099</td>
              <td data-label="Email ID">vikaskumar@example.com</td>
            </tr>
            <tr>
              <td scope="row" data-label="Name">Vikas Kumar</td>
              <td data-label="Designation">Teacher</td>
              <td data-label="Institute">Delhi Public School</td>
              <td data-label="Phone">9876543210</td>
              <td data-label="Extension">099</td>
              <td data-label="Email ID">vikaskumar@example.com</td>
            </tr>
            <tr>
              <td scope="row" data-label="Name">Vikas Kumar</td>
              <td data-label="Designation">Teacher</td>
              <td data-label="Institute">Delhi Public School</td>
              <td data-label="Phone">9876543210</td>
              <td data-label="Extension">099</td>
              <td data-label="Email ID">vikaskumar@example.com</td>
            </tr>
            <tr>
              <td scope="row" data-label="Name">Vikas Kumar</td>
              <td data-label="Designation">Teacher</td>
              <td data-label="Institute">Delhi Public School</td>
              <td data-label="Phone">9876543210</td>
              <td data-label="Extension">099</td>
              <td data-label="Email ID">vikaskumar@example.com</td>
            </tr>
          </tbody>
        </table>      </div>
      <div class="clearfix"></div>
    </div>
  </div>
</section> -->


<div class="row">
  <div class="col-md-12 col-sm-12 col-xs-12 nopad">
      <h2 class="SectionHeading">Directory</h2>
  </div>
</div>

<div id="listView" class="container bannerSection boxShadow tab-pane active" style="padding:30px;">
  <div class="col-md-12 col-sm-12 col-xs-12 nopad">
  <table>
    <thead>
      <tr>
        <th scope="col">S.No.</th>
        <th scope="col">Name</th>
        <th scope="col">Designation</th>
        <th scope="col">Phone</th>
        <th scope="col">Extension</th>
        <th scope="col">Email ID</th>
      </tr>
    </thead>
    <tbody *ngFor='let element of directories;'>
        <tr style="background-color: rgba(0, 0, 0, 0.05);" class="designtion_type">
          <td colspan="6">{{element[0]}}</td>
        </tr>
        <tr *ngFor='let directory of element[1];let i=index;'>
          <td scope="row" data-label="sno" class="sno">{{i+1}}</td>
          <td scope="row" data-label="Name" class="name">{{directory['name']}}</td>
          <td scope="row" data-label="Designation" class="designation">{{directory['designation']}}</td>
          <td scope="row" data-label="Phone" class="phone">{{directory['phone']}}</td>
          <td scope="row" data-label="Extension" class="extension">{{directory['extension']}}</td>
          <td scope="row" data-label="Email ID" class="email">{{directory['email']}}</td>
        </tr>  
    </tbody>
  </table> 
</div>
</div>


<!-- <div id="listView" class="container bannerSection boxShadow tab-pane active" style="padding:30px;">
  <div class="col-md-12 col-sm-12 col-xs-12 nopad">
  <div class="clearfix"></div>


  <mat-table #matTable class="dataTable" [dataSource]="dataSource" matSort #sort="matSort">
    <ng-container matColumnDef="sno">
        <mat-header-cell *matHeaderCellDef> S No. </mat-header-cell>
        <mat-cell *matCellDef="let i=index;"> {{i+1}} </mat-cell>
    </ng-container>

    <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef> Name </mat-header-cell>
        <mat-cell *matCellDef="let element">{{element?.name}} </mat-cell>
    </ng-container>

    <ng-container matColumnDef="designation">
        <mat-header-cell *matHeaderCellDef> Designation </mat-header-cell>
        <mat-cell *matCellDef="let element">{{element?.designation}} </mat-cell>
    </ng-container>

    <ng-container matColumnDef="phone">
        <mat-header-cell *matHeaderCellDef> Phone No. </mat-header-cell>
        <mat-cell *matCellDef="let element">{{element?.phone}} </mat-cell>
    </ng-container>

    <ng-container matColumnDef="extension">
      <mat-header-cell *matHeaderCellDef> Extension </mat-header-cell>
      <mat-cell *matCellDef="let element">{{element?.extension}} </mat-cell>
    </ng-container>

    <ng-container matColumnDef="email">
      <mat-header-cell *matHeaderCellDef> Email ID </mat-header-cell>
      <mat-cell *matCellDef="let element">{{element?.email}} </mat-cell>
    </ng-container>


    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" colspan="4">No data matching the filter</td>
  </tr>

  </mat-table>

 </div>
  <mat-paginator [pageSizeOptions]="[5, 10, 25, 50]" showFirstLastButtons>
</mat-paginator>
</div> -->
